import React, { Component } from 'react';
import { Layout } from '$components/auth';

export default class LayoutRoute extends Component {
  render() {
    return (
      <Layout title={this.props.root.shortTitle}>
        {this.props.children}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/layout.js